module.exports = __webpack_public_path__ + "c443430cdda2b319bcd6b82a04fa0f40.svg";